import app from 'flarum/common/app';

app.initializers.add('mattoid/flarum-ext-store-auto-check-in', () => {
  console.log('[mattoid/flarum-ext-store-auto-check-in] Hello, forum and admin!');
});
